
import { Component, Vue, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { User, Project } from '@/types';
import { getUserProjects, getUserWallet, replenishUserWallet } from '@/api/services/users';
import { errorHandler } from '@/utils';
import ButtonComponent from '@/components/ButtonComponent.vue';
import ModalComponent from '@/components/ModalComponent.vue';
import InputComponent from '@/components/InputComponent.vue';
import TextareaComponent from '@/components/TextareaComponent.vue';
import SpinnerComponent from '@/components/SpinnerComponent.vue';

const userStore = namespace('user');

@Component({
  components: {
    ButtonComponent,
    ModalComponent,
    InputComponent,
    TextareaComponent,
    SpinnerComponent
  }
})
export default class UserDetailsPage extends Vue {
  @Prop({ type: Object }) user: User.Profile;
  @userStore.State('user') currentUser: User.Profile;

  userProjects: Project.Project[] = [];
  wallet: User.AdminWallet = null;
  isReplenishModalShown: boolean = false;
  replenishForm: User.ReplenishForm = new User.ReplenishForm;

  get socialAccounts() {
    return this.user ? this.user.social_auth.map(it => User.SocialProviderRU[it.provider]) : '';
  }

  get isAdmin(): boolean {
    return !!this.currentUser && String(this.currentUser.role) === 'admin';
  }

  formatMoney(value: number | string): string {
    const num = Number(value);
    if (isNaN(num)) return '—';
    return `${num.toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} ₽`;
  }

  openReplenishModal() {
    this.replenishForm = new User.ReplenishForm;
    this.isReplenishModalShown = true;
  }

  closeReplenishModal() {
    if (this.replenishForm.isLoading) return;
    this.isReplenishModalShown = false;
  }

  async replenish() {
    if (this.replenishForm.isLoading) return;
    this.replenishForm.error = '';
    if (!this.replenishForm.isValid()) return;

    this.replenishForm.isLoading = true;
    try {
      const resp = await replenishUserWallet(
        this.user.id,
        this.replenishForm.amountNumber.toFixed(2),
        this.replenishForm.note.value.trim() || undefined);
      this.wallet = resp.data;
      this.isReplenishModalShown = false;
    } catch (error) {
      const errResponse = error && error.data ? error.data : {};
      const keys = Object.keys(errResponse);
      if (keys.length === 0) this.replenishForm.error = 'Не удалось пополнить баланс. Проверьте, изменился ли он, прежде чем повторять.';
      keys.forEach(it => {
        if (this.replenishForm[it] && this.replenishForm[it].error !== undefined) this.replenishForm[it].error = errorHandler(it, errResponse[it][0]);
        else this.replenishForm.error = errorHandler(it, errResponse[it][0]);
      })
    } finally {
      this.replenishForm.isLoading = false;
    }
  }

  async mounted() {
    try {
      const projects = await getUserProjects(this.user.id);
      this.userProjects = projects.data;
    } catch (error) {
      console.log(error)
    }
    try {
      const wallet = await getUserWallet(this.user.id);
      this.wallet = wallet.data;
    } catch (error) {
      // moderators below senior get 403 here — the balance row is simply hidden
      console.log(error)
    }
  }
}
